module.exports = __webpack_public_path__ + "media/images/captive_portal/Access-points-8b911d5cda1231babd6a593316ab6af7.svg";